import * as i0 from '@angular/core';
import { Injectable, isDevMode, Component, Pipe, ElementRef, Optional, Inject, Directive, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, of, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';

class AssetPathResolverService {
    setPath(path) {
        this.prefix = path;
    }
    getPath(assetPath) {
        return this.prefix + assetPath;
    }
}
AssetPathResolverService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AssetPathResolverService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
AssetPathResolverService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AssetPathResolverService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AssetPathResolverService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class ConsoleService {
    log(message) {
        if (isDevMode !== undefined && isDevMode()) {
            console.log(message);
        }
    }
}
ConsoleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ConsoleService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ConsoleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ConsoleService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ConsoleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class ServicePathProviderService {
    constructor(console) {
        this.console = console;
        this.servicePathMap = new Map();
    }
    setServiceMap(serviceMap) {
        this.console.log('Setting service map containing ' + Object.keys(serviceMap).length + ' mappings.');
        for (const serviceKey of Object.keys(serviceMap)) {
            this.addServiceMapping(serviceKey, serviceMap[serviceKey]);
        }
    }
    addServiceMapping(serviceName, servicePath) {
        this.servicePathMap.set(serviceName, servicePath);
        this.console.log('Adding service mapping: ' + serviceName + ' : ' + servicePath);
    }
    getServicePath(serviceName) {
        const servicePath = this.servicePathMap.get(serviceName);
        if (servicePath === undefined || servicePath.length === 0) {
            this.console.log('No service path for service name: ' + serviceName);
            // throw new Error("No mapping found for service " + serviceName);
        }
        return servicePath;
    }
}
ServicePathProviderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ServicePathProviderService, deps: [{ token: ConsoleService }], target: i0.ɵɵFactoryTarget.Injectable });
ServicePathProviderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ServicePathProviderService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ServicePathProviderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ConsoleService }]; } });

class AuthCheckService {
    constructor(http, serviceLocator, console) {
        this.http = http;
        this.serviceLocator = serviceLocator;
        this.console = console;
        this.isAuth = false;
        this.checkAuthorisation = new BehaviorSubject(false);
    }
    /**
     * @param fastCheck set as true will perform only a check against isAuthenticated,
     * when set to false it'll attempt to perform a full SSO flow with UP,
     * Login flow will only work on same origin URL (external environment) due to use of CORS 302
     */
    isAuthorised(fastCheck = true) {
        const nautilusServicePath = this.serviceLocator.getServicePath('api-gateway');
        const sameOrigin = nautilusServicePath && nautilusServicePath.substr(0, nautilusServicePath.indexOf('/api-gateway')) === window.location.origin;
        const isAuthPath = nautilusServicePath + (!fastCheck && sameOrigin ? '/login' : '/is-authenticated');
        this.console.log(`Using Nautilus service URL: ${isAuthPath} fastCheck: ${fastCheck} sameOrigin: ${sameOrigin}`);
        if (nautilusServicePath) {
            this.authResponse = this.http.get(isAuthPath, { withCredentials: true });
        }
        else {
            this.console.log('No api-gateway path provided - auth response will be false.');
            this.authResponse = of({ isAuthenticated: false });
        }
        return this.authResponse.pipe(map(response => {
            this.handleResponse(response);
            return this.isAuth;
        }, error => {
            this.handleError(error);
            return this.isAuth;
        }));
    }
    handleError(errorResponse) {
        let errMsg;
        if (errorResponse instanceof HttpErrorResponse) {
            const error = JSON.stringify(errorResponse.error);
            errMsg = `${errorResponse.name} - ${errorResponse.message} , Full Error: ${error}`;
        }
        else {
            errMsg = errorResponse.message ? errorResponse.message : errorResponse.toString();
        }
        this.console.log('Assuming not authenticated since the response had to be caught: ' + errMsg);
        this.isAuth = false;
        this.checkAuthorisation.next(false);
    }
    handleResponse(response) {
        if (response && response.isAuthenticated) {
            this.isAuth = response.isAuthenticated;
            this.console.log('Got Nautilus response with isAuth value of: ' + this.isAuth);
            this.checkAuthorisation.next(true);
        }
        else {
            this.console.log('Assuming not authenticated since Nautilus did not return a valid response:\n' + JSON.stringify(response));
            this.isAuth = false;
            this.checkAuthorisation.next(false);
        }
    }
}
AuthCheckService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AuthCheckService, deps: [{ token: i1.HttpClient }, { token: ServicePathProviderService }, { token: ConsoleService }], target: i0.ɵɵFactoryTarget.Injectable });
AuthCheckService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AuthCheckService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AuthCheckService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: ServicePathProviderService }, { type: ConsoleService }]; } });

class DcrInfoIconComponent {
}
DcrInfoIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DcrInfoIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DcrInfoIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: DcrInfoIconComponent, selector: "app-dcr-info-icon", ngImport: i0, template: "<span class=\"dcr-info-icon-wrapper\">\n  <i [ngClass]=\"{ 'animate-opacity': showContent }\" class=\"dcr-info-icon fa fa-info-circle\" (click)=\"showContent = !showContent\"> </i>\n  <span *ngIf=\"showContent\" class=\"dcr-keys animate-opacity text-14\" (click)=\"$event.stopPropagation()\"\n    >Keys used:\n    <ul>\n      <li *ngFor=\"let key of dcrKeys\">\n        <a\n          href=\"{{ key.editLink }}#key={{ key.key }}\"\n          [attr.target]=\"key.dcr\"\n          title=\"DEFAULT: {{ key.defaultValue }} {{ key.dcr }}:{{ key.value }}\"\n          >{{ key.key }}</a\n        >\n        <strong *ngIf=\"key.isUsedDefault\">DEFAULT</strong>\n        <strong *ngIf=\"!key.isUsedDefault && key.isValid\">{{ key.dcr }}</strong>\n        <strong *ngIf=\"!key.isValid\">MISSING</strong>\n      </li>\n    </ul>\n    <ng-container *ngIf=\"dcrSubstitutionKeys\">\n      Available substitution keys:\n      <ul><li *ngFor=\"let key of dcrSubstitutionKeys\">{{key}}</li></ul>\n    </ng-container>\n  </span>\n</span>\n", styles: [".dcr-info-icon-wrapper{z-index:1;position:relative}.dcr-info-icon-wrapper .dcr-keys{position:absolute;bottom:0;left:19px;min-width:250px;border:2px solid yellow;background-color:#000;color:#fff;padding:3px;opacity:.7;text-align:left;font-size:14px;line-height:21px}.dcr-info-icon-wrapper .dcr-keys ul{list-style:none;margin:5px;padding:0}.dcr-info-icon-wrapper .dcr-keys a{text-decoration:none;color:#fff}.dcr-info-icon-wrapper .dcr-keys a:hover{text-decoration:underline}.dcr-info-icon-wrapper .dcr-keys strong{font-size:50%}.dcr-info-icon-wrapper .dcr-info-icon{cursor:pointer;color:#000;font-size:16px;top:0;text-align:left}.dcr-info-icon-wrapper .animate-opacity{animation:opac 1s}@keyframes opac{0%{opacity:0}to{opacity:.7}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DcrInfoIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-dcr-info-icon', template: "<span class=\"dcr-info-icon-wrapper\">\n  <i [ngClass]=\"{ 'animate-opacity': showContent }\" class=\"dcr-info-icon fa fa-info-circle\" (click)=\"showContent = !showContent\"> </i>\n  <span *ngIf=\"showContent\" class=\"dcr-keys animate-opacity text-14\" (click)=\"$event.stopPropagation()\"\n    >Keys used:\n    <ul>\n      <li *ngFor=\"let key of dcrKeys\">\n        <a\n          href=\"{{ key.editLink }}#key={{ key.key }}\"\n          [attr.target]=\"key.dcr\"\n          title=\"DEFAULT: {{ key.defaultValue }} {{ key.dcr }}:{{ key.value }}\"\n          >{{ key.key }}</a\n        >\n        <strong *ngIf=\"key.isUsedDefault\">DEFAULT</strong>\n        <strong *ngIf=\"!key.isUsedDefault && key.isValid\">{{ key.dcr }}</strong>\n        <strong *ngIf=\"!key.isValid\">MISSING</strong>\n      </li>\n    </ul>\n    <ng-container *ngIf=\"dcrSubstitutionKeys\">\n      Available substitution keys:\n      <ul><li *ngFor=\"let key of dcrSubstitutionKeys\">{{key}}</li></ul>\n    </ng-container>\n  </span>\n</span>\n", styles: [".dcr-info-icon-wrapper{z-index:1;position:relative}.dcr-info-icon-wrapper .dcr-keys{position:absolute;bottom:0;left:19px;min-width:250px;border:2px solid yellow;background-color:#000;color:#fff;padding:3px;opacity:.7;text-align:left;font-size:14px;line-height:21px}.dcr-info-icon-wrapper .dcr-keys ul{list-style:none;margin:5px;padding:0}.dcr-info-icon-wrapper .dcr-keys a{text-decoration:none;color:#fff}.dcr-info-icon-wrapper .dcr-keys a:hover{text-decoration:underline}.dcr-info-icon-wrapper .dcr-keys strong{font-size:50%}.dcr-info-icon-wrapper .dcr-info-icon{cursor:pointer;color:#000;font-size:16px;top:0;text-align:left}.dcr-info-icon-wrapper .animate-opacity{animation:opac 1s}@keyframes opac{0%{opacity:0}to{opacity:.7}}\n"] }]
        }] });

class TranslationState {
    constructor(_key, _value, _defaultValue, _editLinkMap, _dcr) {
        this._key = _key;
        this._value = _value;
        this._defaultValue = _defaultValue;
        this._editLinkMap = _editLinkMap;
        this._dcr = _dcr;
        this.resolved = this.value || this._defaultValue || '';
    }
    get key() {
        return this._key;
    }
    get value() {
        return this._value;
    }
    get dcr() {
        return this._dcr;
    }
    get defaultValue() {
        return this._defaultValue;
    }
    get editLink() {
        return this._editLinkMap[this.dcr];
    }
    get isUsedDefault() {
        if (this._defaultValue && !this._value) {
            return true;
        }
        else {
            return false;
        }
    }
    get isValid() {
        if (this._value || this._defaultValue) {
            return true;
        }
        else {
            return false;
        }
    }
    toString() {
        return this.resolved;
    }
}

/**
 * Created by ghanjra on 7/19/2017.
 */
class DomHelper {
    static getQueryParameters() {
        const queryDict = {};
        window.location.search
            .substr(1)
            .split('&')
            .forEach(function (item) {
            queryDict[item.split('=')[0]] = item.split('=')[1];
        });
        return queryDict;
    }
}

class DcrKeyPipe {
    transform(input, args) {
        if (!input) {
            return input;
        }
        return this.slugifyTransform(input, '_')?.toUpperCase();
    }
    slugifyTransform(input, format = '-') {
        return input.toString().toLowerCase()
            .replace(/\s+/g, format) // Replace spaces with -
            .replace(/[^a-zA-Z0-9]+/g, format) // Remove all non-word chars
            .replace(new RegExp(`${format}+`, 'g'), format) // Replace multiple - with single -
            .replace(new RegExp(`^${format}+`), '') // Trim - from start of text
            .replace(new RegExp(`${format}+$`), ''); // Trim - from end of text
    }
}
DcrKeyPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DcrKeyPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DcrKeyPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: DcrKeyPipe, name: "dcrKey" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DcrKeyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dcrKey'
                }]
        }] });

class ContentService {
    constructor(selector = '', _elementRef) {
        this._elementRef = _elementRef;
        this.TEST_DCR_KEY = 'testDcr';
        this.id = Math.random();
        this.DCR_QUERY_SELECTOR = '.dcr-data';
        this.MAPPING_QUERY_SELECTOR = '.dcr-mapping';
        this.CWP_COMPONENT_ATTR_SELECTOR = 'data-componentname';
        this.APPLICATION_CONTAINER = 'Application Container';
        this._dcrMapping = new Map();
        this._usedKeys = new Map();
        this._editLink = new Map();
        this._usedKeysChanges = new ReplaySubject(1);
        this.warned = false;
        this._showEditor = DomHelper.getQueryParameters()['showEditor'] === 'true';
        if (_elementRef) {
            if (this._showEditor) {
                console.log(`(${this.id}) Content service got element ref in the constructor `, _elementRef);
            }
            this.initialiseDCRContentFromElem(_elementRef);
        }
        else if (selector) {
            if (this._showEditor) {
                console.log(`(${this.id}) Content service got element selector in the constructor ${selector}`);
            }
            this.initialiseDCRContentFromElemSelector(selector);
        }
        this.initTestDcr();
    }
    initTestDcr() {
        const locationHref = window.location.href;
        if (locationHref.includes(`${this.TEST_DCR_KEY}=true`)) {
            sessionStorage.setItem(this.TEST_DCR_KEY, 'true');
        }
        else if (locationHref.includes(`${this.TEST_DCR_KEY}=false`)) {
            sessionStorage.removeItem(this.TEST_DCR_KEY);
        }
    }
    initialiseDCRContentFromObj(content) {
        this._dcrContent = content;
    }
    initialiseDCRContentFromElemSelector(selectorString) {
        this.initialiseDCRContentFromElem(document.querySelector(selectorString));
    }
    initialiseDCRContentFromElem(element) {
        if (this._dcrContent) {
            console.warn('Content service already initialised, ignoring subsequent call.');
            return;
        }
        /**
         * End DCR Object, which will iterate for any query.
         */
        let content = {};
        /**
         * This is to hold the DOM element we create on CWP side for containing the DCR JSON.
         * refer application-container.ftl in CWP to see the structure of dcr
         */
        let contentElement;
        let dcrMappingElement;
        try {
            const appContainer = this.findMyAppContainer(element instanceof ElementRef ? element.nativeElement : element);
            if (!appContainer) {
                console.warn('AppContainer root element in CWP not found, aborting content service setup.');
                return;
            }
            contentElement = appContainer.querySelector(this.DCR_QUERY_SELECTOR);
            dcrMappingElement = appContainer.querySelector(this.MAPPING_QUERY_SELECTOR);
            try {
                const editLinkList = appContainer.querySelectorAll('.edit a');
                for (let i = 0; i < editLinkList.length; i++) {
                    let elem = editLinkList[i];
                    while (elem && elem.parentElement && !elem.dataset['dcr']) {
                        elem = elem.parentElement;
                    }
                    const link = editLinkList[i].href
                        .replace(ContentService.EDIT_REGEX, '$1')
                        .replace('/iw-cc/edit?vpath=', '/iw-cc/command/iw.ccpro.launch_edit_form?vpath=');
                    if (elem && elem.dataset['dcr']) {
                        this._editLink[elem.dataset['dcr']] = link;
                    }
                    else {
                        this._editLink['targetedDcr'] = link;
                    }
                }
            }
            catch (e) {
                console.log('Failed to initialise edit mode :' + e);
            }
        }
        catch (e) {
            console.error('Error in fetching DCR from CWP component.', e);
            console.log('Chances are you are not running your code in CWP env. So not able to get the hold of the DCR.');
            console.log('For quick fix,try simulating the cwp env. by copying the component wrapper' +
                ' from DOM of CWP page and wrapping you component in your index.html. for example');
            console.log(`<div data-componentname="Application Container" data-tracked-name="blackrock-for-advisors:BFAReportsComponent">
                  <input type="hidden" class="dcr-data" value="{"label":"Investing Insights ","errorMessage":"Leave Me alone","header":"HEADER"}">
                  <app-reports></app-reports>
            </div>`);
        }
        if (contentElement) {
            content = contentElement.getAttribute('value');
        }
        else {
            console.error(`DCR is not attached to the component`, element);
        }
        this._dcrContent = this.isNotEmpty(content) ? JSON.parse(content) : content;
        if (dcrMappingElement) {
            const mappingValue = dcrMappingElement.getAttribute('value');
            this._dcrMapping = this.isNotEmpty(mappingValue) ? JSON.parse(mappingValue) : mappingValue;
        }
    }
    getDcrContent() {
        console.warn('DEPRECATED: DO NOT USE THE DCR OBJECT DIRECTLY. Use contentService.get(key, default) instead!');
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        return this._showEditor
            ? new Proxy(this._dcrContent, {
                get: function (target, name) {
                    if (name.toString() !== 'hasOwnProperty') {
                        const dcrContent = that._dcrMapping[name] ? that._dcrMapping[name] : ContentService.DCR_TARGETED;
                        const translationState = new TranslationState(name.toString(), target[name], null, that._editLink, dcrContent);
                        that.trackTranslation(translationState);
                    }
                    return name in target ? (target[name].value ? target[name].value : target[name]) : null;
                }
            })
            : this._dcrContent;
    }
    getAppContainerProperties(el = this._elementRef) {
        try {
            return this.findMyAppContainer(el.nativeElement).dataset;
        }
        catch (err) {
            return {};
        }
    }
    translateDcrConstants(dcrConstants, prefix, dcr = this._dcrContent) {
        Object.keys(dcrConstants).forEach(key => {
            dcrConstants[key] = this.resolve(prefix + key, dcrConstants[key], dcr).toString();
        });
    }
    isNotEmpty(object) {
        return Object.keys(object).length !== 0;
    }
    findMyAppContainer(componentElement) {
        let parentElement = componentElement;
        while (parentElement && parentElement.getAttribute(this.CWP_COMPONENT_ATTR_SELECTOR) !== this.APPLICATION_CONTAINER) {
            parentElement = parentElement.parentElement;
        }
        return parentElement;
    }
    getResolvedVal(dcrText, dcr = this._dcrContent) {
        const dcrTextArray = dcrText.split('|');
        const dcrExpression = dcrTextArray[0].trim();
        const dcrQuestionCharIndex = dcrExpression.indexOf('?');
        const dcrKey = dcrQuestionCharIndex > 0 ? dcrExpression.substr(0, dcrQuestionCharIndex).trim() : dcrExpression;
        const defaultValue = dcrQuestionCharIndex > -1 ? dcrExpression.substr(dcrQuestionCharIndex + 1).trim() : null;
        const resolvedValue = this.resolve(dcrKey, defaultValue, dcr, false);
        if (dcrTextArray[1]) {
            console.warn(`Inline pipe declaration [${dcrTextArray[1]}] is no longer supported,
      please consider modifying your DCR content if the value you observe is not in the expected format.
      DCR resolved value: ${resolvedValue}`);
        }
        return resolvedValue;
    }
    get(dcrKey, defaultValue, dcr = this._dcrContent, trackKey = true) {
        if (Array.isArray(dcrKey)) {
            return this.resolveWithFallbacks(dcrKey, defaultValue, dcr, trackKey).toString();
        }
        else {
            // it looks like we're passing in numbers and other types as dcr keys
            return this.resolve(dcrKey, defaultValue, dcr, trackKey).toString();
        }
    }
    /** @deprecated Use config service for booleans */
    getBoolean(dcrKey, defaultValue = false) {
        const dcrValue = this.get(dcrKey, defaultValue ? 'true' : 'false');
        return dcrValue && dcrValue.toLowerCase() === 'true';
    }
    getNumber(dcrKey, defaultValue = null) {
        const dcrValue = this.get(dcrKey, defaultValue?.toString());
        return Number(dcrValue);
    }
    validateDcr(dcr) {
        if (!dcr) {
            if (!this.warned) {
                console.warn(`Content Service hasn't been initialised properly!`);
                this.warned = true;
            }
            return {};
        }
        return { ...dcr };
    }
    resolve(dcrKey, defaultValue, dcr = this._dcrContent, trackKey = true) {
        // set dcr key to consistent format - uppercase and underscore
        dcrKey = ContentService.DCR_PIPE.transform(dcrKey);
        // Run ?testDcr=true in the URL to replace all dcr keys with "WORKS!". This gives you an easy check to see which dcr works.
        const testDcr = sessionStorage.getItem(this.TEST_DCR_KEY) === 'true';
        if (testDcr && (defaultValue !== 'true' && defaultValue !== 'false' && !this.isNumber(defaultValue))) {
            return new TranslationState(dcrKey, 'WORKS!', defaultValue, this._editLink, this._dcrMapping[dcrKey] ? this._dcrMapping[dcrKey] : ContentService.DCR_TARGETED);
        }
        dcr = this.validateDcr(dcr);
        if (!dcr[dcrKey]) {
            if (this._showEditor) {
                console.log(`No matching key found for "${dcrKey}" in DCR, falling back to default if provided one.`);
            }
        }
        const translation = new TranslationState(dcrKey, dcr[dcrKey], defaultValue, this._editLink, this._dcrMapping[dcrKey] ? this._dcrMapping[dcrKey] : ContentService.DCR_TARGETED);
        if (trackKey && this._showEditor) {
            this.trackTranslation(translation);
        }
        return translation;
    }
    /**
     * DCR keys are resolved from first to last. This means that the most specific dcr needs to be at the beginning.
     * Example: ['PAGE_1_BAR_LABEL', 'BAR_LABEL']
     */
    resolveWithFallbacks(dcrKeys, defaultValue, dcr = this._dcrContent, trackKey = true) {
        dcr = this.validateDcr(dcr);
        for (const dcrKey of dcrKeys) {
            // set dcr key to consistent format - uppercase and underscore (needs to be done at this level as well to ensure that the same key is used in the if statement)
            const formattedKey = ContentService.DCR_PIPE.transform(dcrKey);
            if (dcr[formattedKey]) {
                return this.resolve(formattedKey, defaultValue, dcr, trackKey);
            }
        }
        return this.resolve(defaultValue, defaultValue, dcr, trackKey);
    }
    trackTranslation(translation) {
        if (!this._usedKeys.has(translation.key)) {
            const temp = new Map(this._usedKeys);
            temp.set(translation.key, translation);
            this._usedKeysChanges.next(temp);
            this._usedKeys = temp;
        }
    }
    getSubstitutedValuesString(messageOrKey, map, defaultText) {
        const translation = this.resolve(messageOrKey, defaultText);
        let message = translation.toString();
        if (!translation.isValid) {
            message = messageOrKey;
        }
        map.forEach((value, key) => {
            const replacement = value !== null && value !== undefined ? value.toString() : '';
            message = message.replace(key, replacement);
        });
        return message;
    }
    getDcrKeyName(textMarkup) {
        return textMarkup.trim().split('?')[0].trim();
    }
    get showEditor() {
        return this._showEditor;
    }
    get usedKeys() {
        return this._usedKeysChanges;
    }
    isNumber(str) {
        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
            !isNaN(parseFloat(str)); // ...and ensure strings of whitespace fail
    }
}
ContentService.DCR_TARGETED = 'targetedDCR';
ContentService.EDIT_REGEX = new RegExp(`.*'(http[^']*).*`);
ContentService.DCR_PIPE = new DcrKeyPipe();
ContentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ContentService, deps: [{ token: 'CONTENT_ELEMENT', optional: true }, { token: i0.ElementRef, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
ContentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ContentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ContentService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['CONTENT_ELEMENT']
                }] }, { type: i0.ElementRef, decorators: [{
                    type: Optional
                }] }]; } });

class DcrContentDirective {
    constructor(_element, _contentService, _componentFactoryResolver, _vcr) {
        this._element = _element;
        this._contentService = _contentService;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._vcr = _vcr;
    }
    ngOnChanges() {
        if (this.dcrContent) {
            this.inflateHostElement(this.dcrContent);
        }
        else if (this.dcrHTMLKey) {
            this.populateHTMLContent(this.dcrHTMLKey);
        }
        if (this.dcrKeys) {
            this.attachDcrIcon(this._element.nativeElement, this.dcrKeys.map(val => new TranslationState(val, null, null, new Map(), null)));
        }
    }
    populateHTMLContent(htmlKey) {
        const hostElement = this._element.nativeElement;
        const translationState = typeof htmlKey === 'string' ? this._contentService.resolve(htmlKey, null)
            : this._contentService.resolveWithFallbacks(htmlKey, null);
        const substitutionMap = this.dcrSubstitutions ?
            new Map(Object.keys(this.dcrSubstitutions).map(key => [key, this.dcrSubstitutions[key]])) : null;
        // Only replace the DOM content when the translation is available - otherwise delegate to exiting Angular template
        if (translationState.isValid) {
            let translationString = translationState.toString();
            if (substitutionMap) {
                translationString = this._contentService.getSubstitutedValuesString(translationString, substitutionMap);
            }
            hostElement['innerHTML'] = translationString;
        }
        else {
            if (substitutionMap) {
                let originalDcrContent = hostElement.getAttribute('data-original-dcr-content');
                if (!originalDcrContent) {
                    originalDcrContent = hostElement['innerHTML'];
                    hostElement.setAttribute('data-original-dcr-content', originalDcrContent);
                }
                const translationString = this._contentService.getSubstitutedValuesString(originalDcrContent, substitutionMap);
                hostElement['innerHTML'] = translationString;
            }
        }
        if (this._contentService.showEditor) {
            this.attachDcrIconToHtmlContent(htmlKey, hostElement, translationState);
        }
    }
    attachDcrIconToHtmlContent(htmlKey, hostElement, translationState) {
        if (typeof htmlKey === 'string') {
            this.attachDcrIcon(hostElement, [translationState]);
        }
        else {
            const resolvedKey = translationState.key;
            const availableKeys = htmlKey.map(key => ((key === resolvedKey) ? translationState : new TranslationState(key, null, null, new Map(), null)));
            this.attachDcrIcon(hostElement, availableKeys);
        }
    }
    /**
     * We resolve the value from DCR and inflate the hosting element as required.
     * @param attributeMap Attribute map is what we get from HTML as JSON mapping for [dcrContent]
     */
    inflateHostElement(attributeMap) {
        const hostElement = this._element.nativeElement;
        const keys = [];
        for (const elementAttribute in attributeMap) {
            const val = this._contentService.getResolvedVal(attributeMap[elementAttribute]);
            if (this._contentService.showEditor) {
                keys.push(val);
            }
            // if '' is passed as property of element, just populate the inner text of host element
            if (elementAttribute === '') {
                hostElement.innerText = val.toString();
                // if passed DOM property of element is valid, resolve it accordingly
            }
            else if (typeof this._element.nativeElement[elementAttribute] !== 'undefined') {
                hostElement[elementAttribute] = val;
                // If passed DOM property of element is invalid(misspelled perhaps), display an error.
            }
            else {
                console.error(`Wrong usage of dcrContent Directive, attribute -- ${elementAttribute} -- does not not exist on element ` + hostElement.outerHTML);
            }
        }
        this.attachDcrIcon(hostElement, keys);
    }
    /**
     * This attaches the DCR icon which apppears only if showEditor=true
     * @param hostElement
     * @param dcrKeys
     */
    attachDcrIcon(hostElement, dcrKeys) {
        if (!this._contentService.showEditor) {
            return;
        }
        // Highlight the element that used this directive
        hostElement.classList.add('show-edit-mode');
        // Create the info-icon component and add that to the element
        const dcrIconFactory = this._componentFactoryResolver.resolveComponentFactory(DcrInfoIconComponent);
        const dcrIcon = this._vcr.createComponent(dcrIconFactory, 0).instance;
        // Passing inputs to DcrIcon component as they are required by it.
        dcrIcon.dcrKeys = dcrKeys;
        if (this.dcrSubstitutions) {
            dcrIcon.dcrSubstitutionKeys = Object.keys(this.dcrSubstitutions);
        }
    }
}
DcrContentDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DcrContentDirective, deps: [{ token: i0.ElementRef }, { token: ContentService }, { token: i0.ComponentFactoryResolver }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
DcrContentDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.9", type: DcrContentDirective, selector: "[dcrContent],[dcrHTMLKey],[dcrKeys]", inputs: { dcrContent: "dcrContent", dcrHTMLKey: "dcrHTMLKey", dcrSubstitutions: "dcrSubstitutions", dcrKeys: "dcrKeys" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DcrContentDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[dcrContent],[dcrHTMLKey],[dcrKeys]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: ContentService }, { type: i0.ComponentFactoryResolver }, { type: i0.ViewContainerRef }]; }, propDecorators: { dcrContent: [{
                type: Input
            }], dcrHTMLKey: [{
                type: Input
            }], dcrSubstitutions: [{
                type: Input
            }], dcrKeys: [{
                type: Input
            }] } });

class DcrPipe {
    constructor(contentService) {
        this.contentService = contentService;
    }
    transform(defaultStr, dcrKey) {
        return this.contentService.get(dcrKey, defaultStr);
    }
}
DcrPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DcrPipe, deps: [{ token: ContentService }], target: i0.ɵɵFactoryTarget.Pipe });
DcrPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: DcrPipe, name: "dcr" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DcrPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'dcr' }]
        }], ctorParameters: function () { return [{ type: ContentService }]; } });

/**
 * This directive is supposed to be placed within the top level element of the app component
 * it'll mark the placeholder of the used translation keys wihtin the application code and initialise the content if not already.
 */
class EnableContentDirective {
    constructor(_element, _contentService, _componentFactoryResolver, _vcr) {
        this._element = _element;
        this._contentService = _contentService;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._vcr = _vcr;
    }
    ngOnInit() {
        if (!this._contentService.getDcrContent()) {
            console.log(`EnableContent initialise content service ${this._contentService.id} from `, this._element);
            this._contentService.initialiseDCRContentFromElem(this._element);
        }
        if (this._contentService.showEditor) {
            console.log(`EnableContent uses content service ${this._contentService.id} from `, this._element);
            this.attachDcrIcon(this._element.nativeElement);
        }
    }
    /**
     * This attaches the DCR icon which apppears only if showEditor=true
     * @param hostElement
     * @param dcrKeys
     */
    attachDcrIcon(hostElement) {
        // Highlight the element that used this directive
        // hostElement.classList.add('show-edit-mode');
        // Create the info-icon component and add that to the element
        const dcrIconFactory = this._componentFactoryResolver.resolveComponentFactory(DcrInfoIconComponent);
        const dcrIcon = this._vcr.createComponent(dcrIconFactory, 0).instance;
        // Passing inputs to DcrIcon component as they are required by it.
        dcrIcon.dcrKeys = [];
        this._contentService.usedKeys.subscribe(keys => {
            dcrIcon.dcrKeys = Array.from(keys.values());
        });
    }
}
EnableContentDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EnableContentDirective, deps: [{ token: i0.ElementRef }, { token: ContentService }, { token: i0.ComponentFactoryResolver }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
EnableContentDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.9", type: EnableContentDirective, selector: "[enableContent]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EnableContentDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[enableContent]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: ContentService }, { type: i0.ComponentFactoryResolver }, { type: i0.ViewContainerRef }]; } });

class HrefResolverService {
    constructor(console) {
        this.console = console;
        this.urlMap = new Map();
        // temporary hack - to bypass url resolver error in npm start mode
        if (window.location.href === 'http://localhost:4200/') {
            this.urlMap.set('screenerDefault', 'http://localhost:1776/fund-buyer-portal/en-ch/products/product-list');
            this.urlMap.set('mySubscriptions', 'http://localhost:1776/fund-buyer-portal/en-ch/services/gls/subscription/gls-subscription.jsn');
        }
    }
    setUrlMap(jsonUrlMap) {
        this.console.log('Setting url map : ' + JSON.stringify(jsonUrlMap));
        for (const namedUrl of Object.keys(jsonUrlMap)) {
            this.urlMap.set(namedUrl, jsonUrlMap[namedUrl]);
            this.console.log(JSON.stringify(namedUrl) + ' ' + JSON.stringify(jsonUrlMap[namedUrl]));
        }
    }
    getResolvedUrl(hrefValue) {
        this.console.log('Got href value: ' + hrefValue);
        const resolvedUrl = this.urlMap.get(hrefValue);
        this.console.log('Resolved: ' + resolvedUrl + ' using key: ' + hrefValue);
        if (resolvedUrl === undefined) {
            console.error('Could not resolve a urlMap value for key: ' + hrefValue);
        }
        return resolvedUrl;
    }
}
HrefResolverService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HrefResolverService, deps: [{ token: ConsoleService }], target: i0.ɵɵFactoryTarget.Injectable });
HrefResolverService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HrefResolverService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HrefResolverService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ConsoleService }]; } });

class HrefResolverDirective {
    constructor(elementRef, hrefResolver, console) {
        this.elementRef = elementRef;
        this.hrefResolver = hrefResolver;
        this.console = console;
        this.hrefArgs = '';
        this.isInitialised = false;
        this.hrefValue = '';
        this.resolvedHref = '';
        this.varDelimiter = '';
    }
    ngOnInit() {
        const providedKey = this.elementRef.nativeElement.getAttribute('href');
        this.resolvedHref = this.hrefResolver.getResolvedUrl(providedKey);
        // this.console.log('ngOnInit -- href is: ' + providedKey + ' resolved href is: ' + this.resolvedHref + ' args are: ' + this.hrefArgs);
        this.updateHref();
        this.isInitialised = true;
    }
    ngOnChanges() {
        if (this.isInitialised) {
            this.updateHref();
        }
    }
    updateHref() {
        const newHref = this.resolvedHref + this.varDelimiter + this.hrefArgs;
        // this.console.log('href change from: ' + this.hrefValue + ' to: ' + newHref);
        this.hrefValue = newHref;
        const hrefValue = this.elementRef.nativeElement.setAttribute('href', this.hrefValue);
    }
}
HrefResolverDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HrefResolverDirective, deps: [{ token: i0.ElementRef }, { token: HrefResolverService }, { token: ConsoleService }], target: i0.ɵɵFactoryTarget.Directive });
HrefResolverDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.9", type: HrefResolverDirective, selector: "[hrefResolver]", inputs: { hrefArgs: "hrefArgs" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HrefResolverDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[hrefResolver]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: HrefResolverService }, { type: ConsoleService }]; }, propDecorators: { hrefArgs: [{
                type: Input
            }] } });

/**
 * dcrIf checks if the value of the DCR key passed in is 'true'/'false'. If the value doesn't exist, the DOM element is hidden.
 * Example usage:
 *    <div *dcrIf="'A_KEY_WHICH_RETURNS_TRUE'">Something</div>
 *    <div *dcrIf="'A_KEY_WHICH_RETURNS_TRUE'; default: true">Something</div>
 * The above will be displayed.
 *
 *
 * dcrIfExists checks if there is the DCR key has a value. If a value exists, the DOM element is shown.
 * Example usage:
 *    <div *dcrIfExists="'A_KEY_WHICH_DOESNT_EXIST'">Something</div>
 *    <div *dcrIfExists="'A_KEY_WHICH_DOESNT_EXIST'; default: true">Something</div>
 * This above will not be displayed.
 *
 */
class DcrIfDirective {
    constructor(contentService, viewContainerRef, templateRef) {
        this.contentService = contentService;
        this.viewContainerRef = viewContainerRef;
        this.templateRef = templateRef;
        this._dcrIf = null;
        this._dcrIfExists = null;
        this._dcrDefaultValue = false;
        this.isContentShown = false; // to avoid double elements showing
    }
    set dcrIf(conditionKey) {
        this._dcrIf = conditionKey;
        this.toggleDomVisibility();
    }
    set dcrIfDefault(defaultValue) {
        this._dcrDefaultValue = defaultValue;
        this.toggleDomVisibility();
    }
    set dcrIfExists(conditionKey) {
        this._dcrIfExists = conditionKey;
        this.toggleDomVisibility();
    }
    set dcrIfExistsDefault(defaultValue) {
        this._dcrDefaultValue = defaultValue;
        this.toggleDomVisibility();
    }
    toggleDomVisibility() {
        let shouldShow = false;
        const defaultValue = this._dcrDefaultValue;
        if (this._dcrIf) {
            shouldShow = this.contentService.getBoolean(this._dcrIf, defaultValue);
        }
        else if (this._dcrIfExists) {
            shouldShow = !!this.contentService.get(this._dcrIfExists, null) || this._dcrDefaultValue;
        }
        if (shouldShow) {
            if (!this.isContentShown) {
                this.viewContainerRef.createEmbeddedView(this.templateRef);
                this.isContentShown = true;
            }
        }
        else {
            this.isContentShown = false;
            this.viewContainerRef.clear();
        }
    }
}
DcrIfDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DcrIfDirective, deps: [{ token: ContentService }, { token: i0.ViewContainerRef }, { token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
DcrIfDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.9", type: DcrIfDirective, selector: "[dcrIf],[dcrIfExists]", inputs: { dcrIf: "dcrIf", dcrIfDefault: "dcrIfDefault", dcrIfExists: "dcrIfExists", dcrIfExistsDefault: "dcrIfExistsDefault" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DcrIfDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[dcrIf],[dcrIfExists]'
                }]
        }], ctorParameters: function () { return [{ type: ContentService }, { type: i0.ViewContainerRef }, { type: i0.TemplateRef }]; }, propDecorators: { dcrIf: [{
                type: Input
            }], dcrIfDefault: [{
                type: Input
            }], dcrIfExists: [{
                type: Input
            }], dcrIfExistsDefault: [{
                type: Input
            }] } });

/**
 * Uses cwp libs to inject a video player using flowplayer.
 *
 * Example:
 * <cwp-video-player videoId="360-evaluator-2020"></cwp-video-player>
 * <cwp-video-player [videoId]="'360-evaluator-2020' | dcr: 'SOME_DCR_KEY'"></cwp-video-player>
 *
 * The video id is the video id from MediaBin.
 *
 * Since this is dependent on CWP libs, you need the following scripts in index.html for this to work
<link rel="stylesheet" type="text/css" href="https://test3.blackrock.com/blk-one-assets/include/common/css/flowplayer/skin.css" />
<script src="https://test3.blackrock.com/blk-one-assets/include/third-party/jquery/jquery-3.5.1.js"></script>
<script src="https://test3.blackrock.com/blk-one-assets/include/common/js/flowplayer.min.js"></script>
<script src="https://test3.blackrock.com/blk-one-assets/include/common/js/blk-video-plugin-html5.js"></script>
<script src="https://test3.blackrock.com/blk-one-assets/include/common/js/video-player.js"></script>
<script src="https://test3.blackrock.com/blk-one-assets/include/one/js/vi16-blk-components.js"></script>
<script src="https://test3.blackrock.com/blk-one-assets/include/common/js/blk-common.js"></script>
 */
class VideoPlayerComponent {
    constructor() {
        this.videoId = '';
        this.videoParams = {};
    }
    ngOnInit() {
        if (!window['videoIdPrefix']) {
            window['videoIdPrefix'] = 'v';
        }
        if (!window['videoIdParam']) {
            window['videoIdParam'] = '';
        }
        if (this.videoId) {
            this.videoParams = {
                'videoId': this.videoId,
                'flashvarsValues': {
                    'fileId': this.videoId,
                    'opt_value': ''
                },
                'player': 'blackrock',
                'isAutoPlay': false
            };
            if (!window['video']) {
                window['video'] = [];
            }
            window['video'].push(this.videoParams);
        }
    }
    ngAfterViewInit() {
        if (window['BLK']) {
            window['BLK'].initVideoPlayer();
        }
    }
}
VideoPlayerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: VideoPlayerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VideoPlayerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: VideoPlayerComponent, selector: "cwp-video-player", inputs: { videoId: "videoId" }, ngImport: i0, template: "<div class=\"video-player vi16\">\n  <div [attr.data-video-params]=\"videoParams\">\n    <div class=\"video-wrapper blackrock\">\n      <div [attr.id]=\"'v' + videoId\" class=\"player\"></div>\n    </div>\n  </div>\n</div>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: VideoPlayerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cwp-video-player', template: "<div class=\"video-player vi16\">\n  <div [attr.data-video-params]=\"videoParams\">\n    <div class=\"video-wrapper blackrock\">\n      <div [attr.id]=\"'v' + videoId\" class=\"player\"></div>\n    </div>\n  </div>\n</div>\n" }]
        }], propDecorators: { videoId: [{
                type: Input
            }] } });

function contentFactory(selector) {
    console.log(`Building ContentService with content from ${selector}`);
    return new ContentService(selector);
}
class CwpNgFrameworkModule {
    static forRoot(selector) {
        return {
            ngModule: CwpNgFrameworkModule,
            providers: [
                { provide: 'CONTENT_ELEMENT', useValue: selector },
                { provide: ContentService, deps: ['CONTENT_ELEMENT'], useFactory: contentFactory }
            ]
        };
    }
}
CwpNgFrameworkModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CwpNgFrameworkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CwpNgFrameworkModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: CwpNgFrameworkModule, bootstrap: [DcrInfoIconComponent], declarations: [HrefResolverDirective,
        DcrIfDirective,
        DcrContentDirective,
        DcrInfoIconComponent,
        EnableContentDirective,
        DcrPipe,
        DcrKeyPipe,
        VideoPlayerComponent], imports: [CommonModule], exports: [HrefResolverDirective,
        DcrIfDirective,
        DcrContentDirective,
        DcrInfoIconComponent,
        EnableContentDirective,
        DcrPipe,
        DcrKeyPipe,
        VideoPlayerComponent] });
CwpNgFrameworkModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CwpNgFrameworkModule, providers: [{ provide: 'CONTENT_ELEMENT', useValue: '' }], imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CwpNgFrameworkModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [
                        HrefResolverDirective,
                        DcrIfDirective,
                        DcrContentDirective,
                        DcrInfoIconComponent,
                        EnableContentDirective,
                        DcrPipe,
                        DcrKeyPipe,
                        VideoPlayerComponent
                    ],
                    exports: [
                        HrefResolverDirective,
                        DcrIfDirective,
                        DcrContentDirective,
                        DcrInfoIconComponent,
                        EnableContentDirective,
                        DcrPipe,
                        DcrKeyPipe,
                        VideoPlayerComponent
                    ],
                    bootstrap: [DcrInfoIconComponent],
                    providers: [{ provide: 'CONTENT_ELEMENT', useValue: '' }]
                }]
        }] });

/*
 * Public API Surface of @blk/cwp-ng-framework
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AssetPathResolverService, AuthCheckService, ConsoleService, ContentService, CwpNgFrameworkModule, DcrContentDirective, DcrIfDirective, DcrInfoIconComponent, DcrKeyPipe, DcrPipe, DomHelper, EnableContentDirective, HrefResolverDirective, HrefResolverService, ServicePathProviderService, TranslationState, VideoPlayerComponent, contentFactory };
